import { useCallback } from 'react';

const useScrollToBottom = () => {
    return useCallback(() => {
        const chatContainer = document.querySelector(".message-container");
        chatContainer.scrollTo({
            top: chatContainer.scrollHeight,
            behavior: "smooth",
        });
    }, []);
};

export default useScrollToBottom;
